export default __webpack_public_path__ + "static/media/1_0010.3461b807.webp";